/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Recharge',
  data: function data() {
    return {
      dataParams: {
        // 人员姓名
        userName: '',
        // 剩余电量
        quantity: 0,
        // 房间名称
        roomName: '',
        // 房间全路径
        roomPathId: '',
        // 是否有照片
        userPhoto: '',
        // 人员工号
        userNo: '',
        // 楼栋名称
        buildName: ''
      },
      //宿舍号
      dormNum: '',
      roomName: null,
      //input提示语
      placeholder: '请选择宿舍号'
    };
  },
  watch: {},
  computed: {},
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getData();

              if (_this.$route.query && _this.$route.query.roomPathId) {
                _this.dormNum = _this.$route.query.roomPathId;
                _this.roomName = _this.$route.query.roomName;
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 获取页面基数数据
    getData: function getData() {
      var _this2 = this;

      this.$api.Power.getUserRoomInfo({
        userSerial: this.$utils.Store.getItem('userSerial')
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.dataParams = data;
          console.log(data, 1111);
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    // 选择宿舍
    isPicker: function isPicker() {
      this.$router.push({
        path: '/powerPicker'
      }); // this.$router.replace({
      //     path: '/powerPicker',
      //   })
    },
    // 跳转
    goLink: function goLink(url, id, name) {
      this.$router.replace({
        path: url,
        query: {
          roomPathId: id,
          roomName: name
        }
      });
    }
  },
  mounted: function mounted() {}
};